// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"carousel_carouselContainer__DK2ve"};